import React from "react";
import Grain from "../Grain/Grain";
import Reveal from "../Reveal/Reveal";
import "./styles.css";

const ITEMS = [
  "Conformidade com a LGPD e as resoluções do CFM",
  "Validação obrigatória do cirurgião antes de qualquer envio",
  "Áudios de transcrição não ficam armazenados",
  "Dados tratados com anonimização e controle de acesso",
  "Login seguro com autenticação por provedor de identidade",
];

const Security = () => (
  <section className="security dark" id="security">
    <div className="glow glow-b" style={{ left: -140, right: "auto" }} />
    <div className="gridlines" />
    <Grain variant="hard" />
    <Grain variant="soft" />
    <div className="container">
      <Reveal className="section-head">
        <span className="tag">Conformidade</span>
        <h2 className="display">Construído dentro das regras da medicina</h2>
        <p>Segurança, ética e responsabilidade em cada etapa do fluxo</p>
      </Reveal>
      <div className="sec-grid">
        <Reveal className="sec-visual" aria-hidden="true">
          <span className="ring" />
          <span className="ring" />
          <span className="ring" />
          <div className="shield">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6z" />
              <path d="m9 12 2 2 4-4" />
            </svg>
          </div>
        </Reveal>
        <div className="sec-list">
          {ITEMS.map((item, i) => (
            <Reveal className="sec-item" delay={i} key={item}>
              <span className="n">{String(i + 1).padStart(2, "0")}</span>
              <p>{item}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Security;
